module.exports = __webpack_public_path__ + "static/sri-lanka-7be79c972c234d48693a9609991bb892.svg";